import { CheckStatus, Parse, fetchAllPaged, fetchAndParse } from '../utils/ajax';

export default {

    get(authenticationToken) {
        return fetch('/api/admin/1/users/me', {
            headers: {
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    login(username, password) {
        return fetch('/api/draw/1/authentication', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username, password }),
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getTenantUser({ authenticationToken, tenantId, userId }) {
        return fetchAndParse({
            url: `/api/admin/1/users/${userId}`,
            method: 'GET',
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },  
        });
    },

    updateTenantUser({ authenticationToken, tenantId, userId, userPayload }) {
        return fetchAndParse({
            url: `/api/admin/1/users/${userId}`,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
            body: userPayload,
        });
    },

    getUsersForCurrentTenant({ authenticationToken, tenantId, page, pageSize }) {
        // API has a maximum page size of 1000
        return fetch(`/api/admin/1/users?pageSize=${pageSize}&page=${page}`, {
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getAllUsersForCurrentTenant({ authenticationToken, tenantId }) {
        // API has a maximum page size of 1000
        return fetchAllPaged(this.getUsersForCurrentTenant, { authenticationToken, tenantId }, 1000);
    },

    addUserToCurrentTenant({ authenticationToken, tenantId, firstName, lastName, email }) {
        // API has a maximum page size of 1000
        return fetch('/api/admin/1/users', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
            body: JSON.stringify({ firstName, lastName, email }),
        })
            .then(CheckStatus)
            .then(Parse);
    },

    removeUserFromTenant({ id, authenticationToken, tenantId }) {
        // API has a maximum page size of 1000
        return fetch(`/api/admin/1/users/${id}`, {
            method: 'DELETE',
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getCurrentUserNotifications({ authenticationToken }) {
        return fetch('/api/notifications/1/me?includeRead=true', {
            method: 'GET',
            headers: {
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getSingleUserNotification({ id, authenticationToken }) {
        return fetch(`/api/notifications/1/${id}`, {
            method: 'GET',
            headers: {
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    readAllUserNotifications({ authenticationToken }) {
        return fetch('/api/notifications/1/me/read', {
            method: 'POST',
            headers: {
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    requestPasswordReset({ email }) {
        const { href } = window.location;
        return fetchAndParse({
            url: `/api/admin/1/directory/user/password?email=${encodeURIComponent(email)}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: {
                redirectUrl: `${href}?reset-result={0}&reset-callback-uri={1}`,
            },    
        });
    },

    changePassword({ callbackUri, password }) {
        return fetchAndParse({
            url: callbackUri,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: {
                password,
            },    
        });
    },

    getKeys(authenticationToken) {        
        return fetchAndParse({
            url: '/api/admin/1/users/me/keys',
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authenticationToken,
            },
        });
    },

    postKey({ authenticationToken, keyName, tenantId }) {
        return fetchAndParse({
            url: '/api/admin/1/users/me/keys',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authenticationToken,
            },
            body: {
                name: keyName,
                tenantId,
            },
        });
    },

    deleteKey({ authenticationToken, keyName }) {
        return fetchAndParse({
            url: `/api/admin/1/users/me/keys/${keyName}`,
            method: 'DELETE',
            headers: {
                Authorization: authenticationToken,
            },
        });
    },
};
